import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Swiper from 'swiper';
import { Keyboard, Pagination } from 'swiper/modules';
import { getNextDiscussion } from '../discussionNavigation';

const BOUNDARY_SWIPE_THRESHOLD = 32;

export default class MediaGallery extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.activeIndex = 0;
    this.swiper = null;
    this.touchStartX = null;
    this.isNavigating = false;
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    if (this.attrs.media.length) {
      const hasMultipleMedia = this.attrs.media.length > 1;

      this.swiper = new Swiper(vnode.dom.querySelector('.swiper'), {
        modules: hasMultipleMedia ? [Keyboard, Pagination] : [Keyboard],
        slidesPerView: 1,
        spaceBetween: 0,
        threshold: 6,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
          pageUpDown: false,
        },
        ...(hasMultipleMedia
          ? {
              pagination: {
                el: vnode.dom.querySelector('.swiper-pagination'),
                clickable: true,
              },
            }
          : {}),
        on: {
          touchStart: (swiper) => {
            this.touchStartX = swiper.touches.startX;
          },
          touchEnd: (swiper) => {
            this.handleBoundarySwipe(swiper);
          },
          slideChange: (swiper) => {
            this.updateCounter(swiper);
          },
        },
      });
    }
  }

  handleBoundarySwipe(swiper) {
    const startX = this.touchStartX;
    const currentX = swiper.touches.currentX;
    const diff = typeof currentX === 'number' && typeof startX === 'number' ? currentX - startX : swiper.touches.diff;
    const isSingleMedia = this.attrs.media.length === 1;
    const isBoundarySwipe = swiper.swipeDirection === 'next' || (isSingleMedia && swiper.swipeDirection === 'prev');

    this.touchStartX = null;

    if (
      this.isNavigating ||
      typeof startX !== 'number' ||
      !swiper.isEnd ||
      !isBoundarySwipe ||
      typeof diff !== 'number' ||
      (!isSingleMedia && diff > -BOUNDARY_SWIPE_THRESHOLD) ||
      (isSingleMedia && Math.abs(diff) < BOUNDARY_SWIPE_THRESHOLD)
    ) {
      return;
    }

    const discussion = this.attrs.discussion;
    const nextDiscussion = getNextDiscussion(discussion);

    if (!nextDiscussion) return;

    const routeId =
      (typeof nextDiscussion.slug === 'function' && nextDiscussion.slug()) ||
      (typeof nextDiscussion.id === 'function' && nextDiscussion.id());

    if (!routeId || typeof m === 'undefined' || !m.route || typeof m.route.set !== 'function') return;

    this.isNavigating = true;
    m.route.set(app.route('discussion', { id: routeId, near: 1 }));
  }

  updateCounter(swiper) {
    this.activeIndex = swiper.realIndex;

    const counter = swiper.el.closest('.SpacePocketPosts-gallery').querySelector('.SpacePocketPosts-counter');

    if (counter) {
      counter.textContent = `${this.activeIndex + 1}/${this.attrs.media.length}`;
    }
  }

  onremove(vnode) {
    if (this.swiper) this.swiper.destroy(true, true);
    this.swiper = null;
    this.touchStartX = null;
    this.isNavigating = false;
    super.onremove(vnode);
  }

  view() {
    const media = this.attrs.media;
    const total = media.length;

    return (
      <section
        className={'SpacePocketPosts-gallery ' + (total === 1 ? 'is-single' : '')}
        aria-label={app.translator.trans('space-pocket-posts.forum.gallery.label')}
      >
        <div className="swiper">
          <div className="swiper-wrapper">
            {media.map((item, index) => (
              <div className="swiper-slide" key={item.uuid + '-' + index}>
                <img
                  src={item.url}
                  alt={app.translator.trans('space-pocket-posts.forum.gallery.image_alt', {
                    current: index + 1,
                    total,
                  })}
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
          </div>
          {total > 1 && <div className="swiper-pagination" />}
        </div>

        {total > 1 && <span className="SpacePocketPosts-counter" aria-live="polite">{this.activeIndex + 1}/{total}</span>}
      </section>
    );
  }
}
